var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service"},[_c('span',{ref:"icon",class:['mozio-icon']}),_c('span',{staticClass:"mozio-name"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }